;(function () {
	const MOBILE_BREAKPOINT = 750
	const LERP_SPEED = 0.08
	let scrollVideoChromeActiveCount = 0

	const bindControl = (el, handler) => {
		if (!el) return

		el.addEventListener('pointerdown', (e) => {
			e.stopPropagation()
		})

		el.addEventListener('pointerup', (e) => {
			e.preventDefault()
			e.stopPropagation()
			handler(e)
		})
	}

	const setScrollVideoChromeHidden = (hidden) => {
		if (hidden) {
			scrollVideoChromeActiveCount += 1
		} else {
			scrollVideoChromeActiveCount = Math.max(0, scrollVideoChromeActiveCount - 1)
		}
		document.body.classList.toggle(
			'scroll-video-chrome-hidden',
			scrollVideoChromeActiveCount > 0
		)
	}

	const isSectionInScrollZone = (section) => {
		const rect = section.getBoundingClientRect()
		return rect.top <= 0 && rect.bottom > window.innerHeight
	}

	const applyResponsiveVideoSource = (section, video) => {
		const desktopSrc = section.getAttribute('data-desktop-src')
		if (!desktopSrc) return false

		const mobileSrc = section.getAttribute('data-mobile-src') || desktopSrc
		const isMobile = window.innerWidth < MOBILE_BREAKPOINT
		const newSrc = isMobile ? mobileSrc : desktopSrc

		if (video.dataset.activeSrc === newSrc) return false

		video.dataset.activeSrc = newSrc
		video.src = newSrc
		video.load()
		return true
	}

	const initAutoplayVideo = (section) => {
		const video = section.querySelector('.js-autoplay-video__el')
		const btn = section.querySelector('[data-autoplay-play]')
		const muteBtn = section.querySelector('[data-autoplay-mute]')
		const progressTrack = section.querySelector('[data-autoplay-progress]')
		const progressFill = section.querySelector('.image-banner__video-progress-fill')
		const observeTarget =
			section.querySelector('.image-banner__media--autoplay-video') || video
		if (!video || !observeTarget || section._autoplayVideoInitialized) return
		section._autoplayVideoInitialized = true

		const PLAY_VISIBLE_RATIO =
			window.innerWidth < MOBILE_BREAKPOINT ? 0.55 : 0.72
		const PAUSE_VISIBLE_RATIO =
			window.innerWidth < MOBILE_BREAKPOINT ? 0.35 : 0.45

		let userPaused = false
		let userInteracted = false
		let userPrefersMuted = true
		let inView = false
		let pendingAutoplay = false
		let observer = null
		let isDragging = false
		let wasPlayingBeforeDrag = false
		let scrubPointerId = null
		let scrubStartX = 0
		let iosUnlocked = false
		const allowSound = section.getAttribute('data-video-muted') !== 'true'

		video.loop = section.getAttribute('data-video-loop') === 'true'
		video.playsInline = true
		video.setAttribute('playsinline', '')
		video.setAttribute('webkit-playsinline', '')

		const unlockVideo = () => {
			if (iosUnlocked) return
			iosUnlocked = true
			const resumeTime = video.currentTime
			const wasPaused = video.paused
			video
				.play()
				.then(() => {
					if (wasPaused) video.pause()
					video.currentTime = resumeTime
				})
				.catch(() => {
					iosUnlocked = false
				})
		}

		section.addEventListener('touchstart', unlockVideo, {
			once: true,
			passive: true,
		})

		const syncMuteUI = () => {
			section.classList.toggle('is-video-muted', video.muted)
			if (muteBtn) {
				muteBtn.setAttribute(
					'aria-label',
					video.muted ? 'Unmute video' : 'Mute video'
				)
			}
		}

		const applyMuted = (muted) => {
			video.muted = muted
			syncMuteUI()
		}

		const updateProgress = () => {
			if (!progressFill || !video.duration || isDragging) return
			const pct = (video.currentTime / video.duration) * 100
			progressFill.style.width = pct + '%'
		}

		const seekToClientX = (clientX) => {
			if (!progressTrack || !video.duration) return
			const rect = progressTrack.getBoundingClientRect()
			const pct = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1)
			video.currentTime = pct * video.duration
			if (progressFill) progressFill.style.width = pct * 100 + '%'
		}

		const handleDrag = (clientX) => {
			if (clientX == null) return
			seekToClientX(clientX)
		}

		const resumeAfterScrub = () => {
			if (wasPlayingBeforeDrag && !userPaused) {
				const playPromise = video.play()
				if (!playPromise) return
				playPromise
					.then(() => setPlayingState(true))
					.catch(() => setPlayingState(false))
			}
		}

		const finishScrub = () => {
			if (!isDragging) return
			isDragging = false
			resumeAfterScrub()
		}

		if (progressTrack) {
			progressTrack.addEventListener('pointerdown', (e) => {
				if (!video.duration || e.pointerType === 'mouse') return
				userInteracted = true
				unlockVideo()
				scrubPointerId = e.pointerId
				scrubStartX = e.clientX
				isDragging = false
				progressTrack.setPointerCapture(e.pointerId)
			})

			progressTrack.addEventListener('pointermove', (e) => {
				if (e.pointerId !== scrubPointerId || !video.duration) return

				if (
					!isDragging &&
					Math.abs(e.clientX - scrubStartX) < 10
				) {
					return
				}

				if (!isDragging) {
					isDragging = true
					wasPlayingBeforeDrag = !video.paused
					video.pause()
				}

				handleDrag(e.clientX)
			})

			const endScrub = (e) => {
				if (e.pointerId !== scrubPointerId) return

				if (progressTrack.hasPointerCapture(e.pointerId)) {
					progressTrack.releasePointerCapture(e.pointerId)
				}

				scrubPointerId = null

				if (!isDragging) {
					userInteracted = true
					unlockVideo()
					handleDrag(e.clientX)
					return
				}

				finishScrub()
			}

			progressTrack.addEventListener('pointerup', endScrub)
			progressTrack.addEventListener('pointercancel', endScrub)

			progressTrack.addEventListener('mousedown', (e) => {
				if (!video.duration) return
				userInteracted = true
				isDragging = true
				wasPlayingBeforeDrag = !video.paused
				video.pause()
				handleDrag(e.clientX)

				const onMouseMove = (moveEvent) => {
					handleDrag(moveEvent.clientX)
				}

				const onMouseUp = () => {
					document.removeEventListener('mousemove', onMouseMove)
					document.removeEventListener('mouseup', onMouseUp)
					finishScrub()
				}

				document.addEventListener('mousemove', onMouseMove)
				document.addEventListener('mouseup', onMouseUp)
			})
		}

		const getVisibleRatio = (target) => {
			const rect = target.getBoundingClientRect()
			const viewportHeight = window.innerHeight
			const visibleHeight =
				Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0)
			return Math.max(visibleHeight, 0) / Math.max(rect.height, 1)
		}

		const isSufficientlyVisible = (target) =>
			getVisibleRatio(target) >= PLAY_VISIBLE_RATIO

		const shouldPauseForVisibility = (target) =>
			getVisibleRatio(target) < PAUSE_VISIBLE_RATIO

		const updateVisibilityState = () => {
			if (isSufficientlyVisible(observeTarget)) {
				inView = true
				if (!userInteracted) tryAutoplay()
				return
			}

			inView = false
			pendingAutoplay = false

			if (
				!userInteracted &&
				!userPaused &&
				shouldPauseForVisibility(observeTarget)
			) {
				pauseVideo()
			}
		}

		const setPlayingState = (playing) => {
			section.classList.toggle('is-video-playing', playing)
			if (btn) {
				btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video')
			}
		}

		const pauseVideo = () => {
			video.pause()
			setPlayingState(false)
		}

		const playVideo = ({ fromUser = false } = {}) => {
			unlockVideo()

			if (fromUser) {
				applyMuted(allowSound ? userPrefersMuted : true)
			} else {
				applyMuted(true)
			}

			const attemptPlay = () => {
				const playPromise = video.play()
				return playPromise || Promise.resolve()
			}

			attemptPlay()
				.then(() => setPlayingState(true))
				.catch(() => {
					if (fromUser && allowSound && !video.muted) {
						applyMuted(true)
						return attemptPlay()
							.then(() => setPlayingState(true))
							.catch(() => setPlayingState(false))
					}
					setPlayingState(false)
				})
		}

		const tryAutoplay = () => {
			if (userPaused || userInteracted || !inView) return

			if (video.readyState < HTMLMediaElement.HAVE_FUTURE_DATA) {
				pendingAutoplay = true
				return
			}

			pendingAutoplay = false
			playVideo({ fromUser: false })
		}

		const refreshSource = () => {
			const sourceChanged = applyResponsiveVideoSource(section, video)
			if (sourceChanged) {
				pendingAutoplay = inView && !userPaused
			}
		}

		refreshSource()

		if (!section.getAttribute('data-desktop-src') && video.querySelector('source')) {
			video.load()
		}

		video.addEventListener('loadedmetadata', () => {
			if (video.videoWidth && video.videoHeight) {
				observeTarget.style.aspectRatio = `${video.videoWidth} / ${video.videoHeight}`
			}
			if (pendingAutoplay || (inView && !userPaused)) {
				tryAutoplay()
			}
		})

		video.addEventListener('loadeddata', () => {
			if (pendingAutoplay || (inView && !userPaused)) {
				tryAutoplay()
			}
		})

		video.addEventListener('canplay', () => {
			if (pendingAutoplay || (inView && !userPaused)) {
				tryAutoplay()
			}
		})

		const togglePlayback = () => {
			userInteracted = true
			unlockVideo()

			if (video.paused) {
				userPaused = false
				playVideo({ fromUser: true })
			} else {
				userPaused = true
				pauseVideo()
			}
		}

		bindControl(btn, togglePlayback)

		bindControl(muteBtn, () => {
			userInteracted = true
			unlockVideo()
			userPrefersMuted = !video.muted
			applyMuted(userPrefersMuted)

			if (!video.paused) return

			if (!userPrefersMuted && allowSound) {
				userPaused = false
				playVideo({ fromUser: true })
			}
		})

		userPrefersMuted = true
		applyMuted(true)

		video.addEventListener('timeupdate', updateProgress)
		video.addEventListener('play', () => setPlayingState(true))
		video.addEventListener('pause', () => setPlayingState(false))
		video.addEventListener('ended', () => {
			if (!video.loop) setPlayingState(false)
		})
		video.addEventListener('loadedmetadata', () => {
			updateProgress()
		})

		if ('IntersectionObserver' in window) {
			observer = new IntersectionObserver(
				() => {
					updateVisibilityState()
				},
				{
					threshold: [0, 0.25, 0.45, 0.55, 0.65, 0.72, 0.85, 1],
					rootMargin: '0px 0px -5% 0px',
				}
			)
			observer.observe(observeTarget)

			requestAnimationFrame(updateVisibilityState)
		} else {
			inView = isSufficientlyVisible(observeTarget)
			tryAutoplay()
		}

		section._autoplayVideoResizeHandler = refreshSource
		window.addEventListener('resize', section._autoplayVideoResizeHandler)

		section._autoplayVideoCleanup = () => {
			if (observer) observer.disconnect()
			if (section._autoplayVideoResizeHandler) {
				window.removeEventListener('resize', section._autoplayVideoResizeHandler)
			}
			pauseVideo()
			section._autoplayVideoInitialized = false
		}
	}

	const initScrollVideo = (section) => {
		const video = section.querySelector('.js-scroll-video__el')
		if (!video || section._scrollVideoInitialized) return
		section._scrollVideoInitialized = true

		const hint = section.querySelector('.image-banner__scroll-hint')
		const progressTrack = section.querySelector('.image-banner__scroll-progress-track')
		const progressFill = section.querySelector('.image-banner__scroll-progress-fill')

		let videoReady = false
		let videoDuration = 0
		let targetTime = 0
		let currentTime = 0
		let animating = false
		let isDragging = false
		let iosUnlocked = false
		let inScrollZone = false

		const setContainerHeight = () => {
			const isMobile = window.innerWidth < MOBILE_BREAKPOINT
			const scrollSpeed = isMobile
				? section.getAttribute('data-mobile-scroll') || '400'
				: section.getAttribute('data-desktop-scroll') || '400'
			section.style.height = 'calc(100vh + ' + scrollSpeed + 'vh)'
		}

		const applyVideoSource = () => {
			if (!applyResponsiveVideoSource(section, video)) return false
			videoReady = false
			videoDuration = 0
			currentTime = 0
			targetTime = 0
			return true
		}

		setContainerHeight()
		applyVideoSource()

		const unlockVideo = () => {
			if (iosUnlocked) return
			iosUnlocked = true
			video
				.play()
				.then(() => {
					video.pause()
					video.currentTime = currentTime
				})
				.catch(() => {
					iosUnlocked = false
				})
		}
		document.addEventListener('touchstart', unlockVideo, { once: true })

		const getScrollProgress = () => {
			const rect = section.getBoundingClientRect()
			const scrollableDistance = section.offsetHeight - window.innerHeight
			if (scrollableDistance <= 0) return 0
			const scrolled = -rect.top
			return Math.min(Math.max(scrolled / scrollableDistance, 0), 1)
		}

		const startAnimationLoop = () => {
			if (animating) return
			animating = true
			tick()
		}

		const tick = () => {
			if (!videoReady || !videoDuration) {
				animating = false
				return
			}

			if (!isDragging) {
				const progress = getScrollProgress()
				targetTime = progress * videoDuration
			}

			const diff = targetTime - currentTime
			if (Math.abs(diff) > 0.01) {
				currentTime += diff * LERP_SPEED
				video.currentTime = currentTime
			} else {
				currentTime = targetTime
			}

			if (progressFill) {
				const pct = (currentTime / videoDuration) * 100
				progressFill.style.width = pct + '%'
			}

			requestAnimationFrame(tick)
		}

		const onVideoReady = () => {
			videoReady = true
			videoDuration = video.duration
			currentTime = 0
			targetTime = 0
			startAnimationLoop()
		}

		video.addEventListener('loadedmetadata', onVideoReady)
		if (video.readyState >= 1) onVideoReady()

		const onScrollHint = () => {
			const inZone = isSectionInScrollZone(section)
			if (inZone !== inScrollZone) {
				inScrollZone = inZone
				setScrollVideoChromeHidden(inZone)
			}

			if (!hint) return
			const progress = getScrollProgress()
			if (progress < 0.02) {
				hint.classList.remove('is-hidden')
			} else {
				hint.classList.add('is-hidden')
			}
		}

		section._scrollVideoHintHandler = onScrollHint
		window.addEventListener('scroll', onScrollHint, { passive: true })
		onScrollHint()

		const syncScrollToVideo = (pct) => {
			const containerRect = section.getBoundingClientRect()
			const scrollableDistance = section.offsetHeight - window.innerHeight
			const targetScroll = window.scrollY + containerRect.top + pct * scrollableDistance
			window.scrollTo({ top: targetScroll, behavior: 'instant' })
		}

		const handleDrag = (e) => {
			if (!progressTrack || !videoDuration) return
			const rect = progressTrack.getBoundingClientRect()
			const pct = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1)
			targetTime = pct * videoDuration
			currentTime = targetTime
			video.currentTime = targetTime
		}

		const endDrag = () => {
			if (!isDragging) return
			isDragging = false
			syncScrollToVideo(currentTime / videoDuration)
		}

		if (progressTrack) {
			progressTrack.addEventListener('click', (e) => {
				if (!videoDuration) return
				const rect = progressTrack.getBoundingClientRect()
				const pct = (e.clientX - rect.left) / rect.width
				targetTime = pct * videoDuration
				currentTime = targetTime
				video.currentTime = targetTime
				syncScrollToVideo(pct)
			})

			progressTrack.addEventListener('mousedown', (e) => {
				isDragging = true
				handleDrag(e)
				e.preventDefault()
			})

			progressTrack.addEventListener(
				'touchstart',
				(e) => {
					isDragging = true
					e.preventDefault()
					handleDrag(e.touches[0])
				},
				{ passive: false }
			)
		}

		section._scrollVideoMouseMove = (e) => {
			if (!isDragging) return
			handleDrag(e)
		}

		section._scrollVideoTouchMove = (e) => {
			if (!isDragging) return
			e.preventDefault()
			handleDrag(e.touches[0])
		}

		section._scrollVideoEndDrag = endDrag

		document.addEventListener('mousemove', section._scrollVideoMouseMove)
		document.addEventListener('touchmove', section._scrollVideoTouchMove, { passive: false })
		document.addEventListener('mouseup', section._scrollVideoEndDrag)
		document.addEventListener('touchend', section._scrollVideoEndDrag)

		section._scrollVideoResizeHandler = () => {
			setContainerHeight()
			applyVideoSource()
			onScrollHint()
		}
		window.addEventListener('resize', section._scrollVideoResizeHandler)

		section._scrollVideoCleanup = () => {
			animating = false
			if (inScrollZone) {
				inScrollZone = false
				setScrollVideoChromeHidden(false)
			}
			if (section._scrollVideoHintHandler) {
				window.removeEventListener('scroll', section._scrollVideoHintHandler)
			}
			if (section._scrollVideoResizeHandler) {
				window.removeEventListener('resize', section._scrollVideoResizeHandler)
			}
			if (section._scrollVideoMouseMove) {
				document.removeEventListener('mousemove', section._scrollVideoMouseMove)
			}
			if (section._scrollVideoTouchMove) {
				document.removeEventListener('touchmove', section._scrollVideoTouchMove)
			}
			if (section._scrollVideoEndDrag) {
				document.removeEventListener('mouseup', section._scrollVideoEndDrag)
				document.removeEventListener('touchend', section._scrollVideoEndDrag)
			}
			section.style.height = ''
			section._scrollVideoInitialized = false
		}
	}

	const initSection = (section) => {
		if (section._initialized) return
		section._initialized = true

		if (section.hasAttribute('data-autoplay-video')) {
			initAutoplayVideo(section)
			return
		}

		if (section.hasAttribute('data-scroll-video')) {
			initScrollVideo(section)
		}

		const sectionAnimated = section.querySelector('.image-banner__container')
		const heading = section.querySelector('.image-banner__heading')

		if (!sectionAnimated || section.hasAttribute('data-scroll-video')) return

		const { animation, imageRatio } = section.dataset
		const isAnimation = animation == 'true' && imageRatio == 'large'

		function changeSectionSizes() {
			const sectionTop = section.getBoundingClientRect().top
			const windowHeight = window.innerHeight
			const desktopAnimated = window.innerWidth >= MOBILE_BREAKPOINT && isAnimation

			if (!desktopAnimated) {
				sectionAnimated.style.borderRadius = ''
				sectionAnimated.style.overflow = ''
				sectionAnimated.style.width = ''
				sectionAnimated.style.height = ''
				if (heading) heading.style.opacity = ''
				return
			}

			if (sectionTop <= 0) {
				const scrollProgress = Math.abs(sectionTop) / windowHeight
				const clampedProgress = Math.min(Math.max(scrollProgress, 0), 1)
				const newSize = 50 + 50 * clampedProgress

				if (heading) {
					heading.style.opacity = `${clampedProgress}`
				}

				if (newSize < 75) {
					sectionAnimated.style.borderRadius = 'var(--border-radius-main)'
					sectionAnimated.style.overflow = 'hidden'
				} else {
					sectionAnimated.style.borderRadius = '0'
					sectionAnimated.style.overflow = ''
				}
				sectionAnimated.style.width = `${newSize}%`
				sectionAnimated.style.height = `${newSize}%`
			} else {
				if (heading) {
					heading.style.opacity = '0'
				}
				sectionAnimated.style.borderRadius = 'var(--border-radius-main)'
				sectionAnimated.style.overflow = 'hidden'
				sectionAnimated.style.width = '50%'
				sectionAnimated.style.height = '50%'
			}
		}

		section._scrollHandler = changeSectionSizes

		if (window.innerWidth >= MOBILE_BREAKPOINT) {
			window.addEventListener('scroll', changeSectionSizes)
		}
		changeSectionSizes()
	}

	const destroySection = (section) => {
		if (section._scrollHandler) {
			window.removeEventListener('scroll', section._scrollHandler)
			section._scrollHandler = null
		}
		if (section._scrollVideoCleanup) {
			section._scrollVideoCleanup()
			section._scrollVideoCleanup = null
		}
		if (section._autoplayVideoCleanup) {
			section._autoplayVideoCleanup()
			section._autoplayVideoCleanup = null
		}
		section._initialized = false
	}

	const initAllSections = () => {
		document.querySelectorAll('.image-banner-container').forEach((section) => {
			initSection(section)
		})
	}

	initAllSections()

	document.addEventListener('shopify:section:load', function (event) {
		const loadedSection = event.target?.querySelector('.image-banner-container')
		if (loadedSection) {
			destroySection(loadedSection)
			initSection(loadedSection)
		} else {
			initAllSections()
		}
	})

	document.addEventListener('shopify:section:unload', function (event) {
		const unloadedSection = event.target?.querySelector('.image-banner-container')
		if (unloadedSection) destroySection(unloadedSection)
	})

	let viewportWasMobile = window.innerWidth < MOBILE_BREAKPOINT

	window.addEventListener('resize', () => {
		const isMobile = window.innerWidth < MOBILE_BREAKPOINT

		document
			.querySelectorAll('.image-banner-container[data-autoplay-video]')
			.forEach((section) => {
				if (section._autoplayVideoResizeHandler) {
					section._autoplayVideoResizeHandler()
				}
			})

		if (isMobile === viewportWasMobile) return

		viewportWasMobile = isMobile
		document.querySelectorAll('.image-banner-container').forEach((section) => {
			destroySection(section)
		})
		initAllSections()
	})
})()
